import * as joint from "jointjs";

const DRAG_THRESHOLD = 4;

/**
 * JointJS creates the bend point on press, on a path over the edge that then swallows the double
 * click. Here it is created only once the pointer moves.
 */
export const createDragToBendTool = (onDoubleClick: (linkView: joint.dia.LinkView) => void) =>
  new ((joint.linkTools.Vertices as any).extend({
    events: {
      "mousedown .joint-vertices-path": "onPathPointerDown",
      "touchstart .joint-vertices-path": "onPathPointerDown",
      "dblclick .joint-vertices-path": "onPathDoubleClick",
    },

    onPathPointerDown(evt: any) {
      if (this.guard(evt)) return;
      evt.stopPropagation();
      evt.preventDefault();

      const start = joint.util.normalizeEvent(evt);
      const startX = start.clientX ?? 0;
      const startY = start.clientY ?? 0;

      const stop = () => {
        document.removeEventListener("mousemove", onMove, true);
        document.removeEventListener("mouseup", stop, true);
      };

      const onMove = (moveEvt: MouseEvent) => {
        const dx = moveEvt.clientX - startX;
        const dy = moveEvt.clientY - startY;
        if (dx * dx + dy * dy < DRAG_THRESHOLD * DRAG_THRESHOLD) return;
        stop();
        this.addVertexAndDrag(start);
      };

      document.addEventListener("mousemove", onMove, true);
      document.addEventListener("mouseup", stop, true);
    },

    // Taken from the library handler unchanged, only called later.
    addVertexAndDrag(start: any) {
      const relatedView = this.relatedView;
      const vertex = this.paper.snapToGrid(start.clientX, start.clientY).toJSON();
      relatedView.model.startBatch("vertex-add", { ui: true, tool: this.cid });
      const index = relatedView.getVertexIndex(vertex.x, vertex.y);
      this.snapVertex(vertex, index);
      relatedView.model.insertVertex(index, vertex, { ui: true, tool: this.cid });
      this.update();
      this.eventData(start, { vertexAdded: true });
      this.handles[index]?.onPointerDown(start);
    },

    // Without passing it on, the path swallows the double click.
    onPathDoubleClick(evt: any) {
      evt.stopPropagation();
      onDoubleClick(this.relatedView);
    },
  }))();
